import React from 'react';
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Divider,
} from '@mui/material';

interface ReferralSubmitDialogProps {
  open: boolean;
  patientName: string;
  clientName: string;
  submitterName: string;
  submitterEmail: string;
}

const ReferralSubmitDialog: React.FC<ReferralSubmitDialogProps> = (
  { open, patientName, clientName, submitterName, submitterEmail }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event:object, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason && reason === "backdropClick")
            return;
      }
    }>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems='center' justifyContent="center" height="250px" width='400px' >
            <Typography variant="h5">Submitting Patient</Typography>
            <Divider/>
            <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" padding={'6px'}>
              <Typography variant="h6"><span style={{fontWeight: 'bold'}}>{`Client: `}</span>{`${clientName}`}</Typography>
              <Typography variant="h6"><span style={{fontWeight: 'bold'}}>{`Patient: `}</span>{`${patientName}`}</Typography>
              <Typography variant="h6"><span style={{fontWeight: 'bold'}}>{`Submitter: `}</span>{`${submitterName}`}</Typography>
              <Typography variant="h6"><span style={{fontWeight: 'bold'}}>{`Contact: `}</span>{`${submitterEmail}`}</Typography>
            </Box>
            <CircularProgress />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralSubmitDialog;